export default "__VITE_ASSET__e01b7453__"